import {
    Box,
    Button,
    Typography,
    TextField,
    MenuItem
} from '@mui/material'
import React, { FormEvent, useState, useEffect } from 'react'
import { message } from 'antd'
import axios from 'axios'
import { FindMerchantUrl, OurDearStateUrl } from '../../common/url'
import { isDesktop } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import IconExpand from '../../assets/repayment-channel/expand.png'
import IconHide from '../../assets/repayment-channel/hide.png'
import IconTip from '../../assets/repayment-channel/tip.png'

export const SMFindMerchant: React.FC = () => {

    const { t } = useTranslation()

    // ======================= HOOKS
    const [step, setStep] = useState(1)


    const [stateList, setStateList] = useState([])
    const [selectedState, setSelectedState] = useState('')

    
    useEffect(() => {
        ; (async () => {
            await fetchList()
        })()
    }, [])

    const fetchList = async () => {
    try {
        const response = await axios.get(OurDearStateUrl)
        console.log('merchant--state接口数据===' + JSON.stringify(response.data['data']))
        var list = []
        var resData = response.data['data']
        for (var i = 0; i < resData.length; i++) {
            var map = resData[i]
            list = [...list, map['attributes']['stateName']]
        }
        setStateList(list)
        } catch (error) {
            console.error(error)
        }
    }

    const stateSelectItem = () => {
        return stateList.map((item, index) => (
            <MenuItem key={index} value={item}>
                {item}
            </MenuItem>
        ))
    }


    const handleStateChange = (event) => {
        setSelectedState(event.target.value)
    }


    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault()

        if (!selectedState) {
            message.destroy()
            message.open({
                type: 'error',
                content: 'State Cannot Be Blank.',
                style: { marginTop: '40vh' },
            })
            return
        }

        setStep(2)


        // var params = {'state': selectedState}


        // message.destroy()
        // message.open({
        //     type: 'loading',
        //     content: 'loading...',
        //     duration: 0,
        //     style: { marginTop: '40vh' },
        // })

        // try {
        //     const response = await axios.post(FindAgreementNoUrl, params)
        //     const code = response.data['code']
        //     console.log('接口返回:', response.data)
        //     message.destroy()

        //     if (code === 200) {
        //         setForms({
        //             nric: '',
        //             vehiclePlateNumber: '',
        //             mobileNumber: '',
        //         })

        //         // 直接使用接口返回的 data 数组
        //         const apiData = response.data.data
        //         if (apiData && apiData.length > 0) {
        //             setStep(2)
        //             // 直接赋值接口数据
        //             setList1(apiData)
        //         } else {
        //             setStep(3)
        //         }
        //     } else {
        //         setStep(4)
        //     }
        // } catch (error) {
        //     message.destroy()
        //     setStep(4)
        // }
    }




     const [expandedItems, setExpandedItems] = useState({})

    // 切换展开状态
    const toggleExpand = (index) => {
        setExpandedItems(prev => ({
        ...prev,
        [index]: !prev[index]
        }))
    }

      // 复制功能
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
        // 可以加一个简单的提示，比如弹出toast
        alert('Copied: ' + text)
        }).catch(() => {
        // 降级方案
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        alert('Copied: ' + text)
        })
    }

  // 商家数据
  const merchants = [
    {
      name: 'LMK MOTOR BIKERS SDN BHD',
      addresses: [
        { phone: '+0176176352', address: 'NO 1, SECTION 87A, JALAN SEMARAK, WP KUALA LUMPUR' },
        { phone: '+0176176333', address: 'NO 41, JALAN SUASA 5, PEKAN SG BESI, WP KUALA LUMPUR' }
      ]
    },
    {
      name: 'DARMA MOTOR SDN BHD',
      addresses: [
        { phone: '+0176176352', address: 'NO 16, JALAN DAMAI PERDANA 5/1, BANDAR DAMAI PERDANA, CHERAS, WP KUALA LUMPUR' }
      ]
    },
    {
      name: 'SKY BIKERS GARAGE SDN BHD',
        addresses: [
        { phone: '+0176173333', address: 'NO 16, AMAI PERDANA, CHERAS, WP KUALA LUMPUR' }
      ]    
    }
  ]

    const item1 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} paddingBottom={'10px'} textAlign={'center'}>
                    {t('t348')}
                </Typography>
                <Typography fontSize={20} fontWeight={500} color={'#141F39'} paddingBottom={'40px'} textAlign={'center'}>
                    {'Find our partner merchants near you'}
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Box sx={{
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        alignItems: 'center',
                        boxShadow: '0px 10px 80px 3px #0000001A',
                        paddingLeft: isDesktop ? '50px' : '25px',
                        paddingRight: isDesktop ? '50px' : '25px',
                        paddingTop: '50px',
                        paddingBottom: '50px',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Box sx={{ width: '100%' }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {'State'} <span style={{ color: '#FF4D49', fontSize: '16', fontWeight: '500' }}>*</span>
                            </Typography>
                            <TextField
                            select
                            fullWidth
                            variant='outlined'
                            value={selectedState}
                            onChange={handleStateChange}
                            InputProps={{ style: { height: '53px' }, sx: {
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#141F39',   // 聚焦时改为黑色
                                    borderWidth: '1px',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#141F39',   // hover 时也改成黑色
                                },
                            } }}
                            SelectProps={{
                                MenuProps: {
                                    anchorOrigin: {
                                        vertical: 'bottom',   // 锚点在下方向
                                        horizontal: 'left',   // 水平左对齐
                                    },
                                    transformOrigin: {
                                        vertical: 'top',      // 菜单从顶部展开
                                        horizontal: 'left',
                                    },
                                    sx: {
                                        '& .MuiPaper-root': {
                                            marginTop: '4px',   // 与输入框的间距
                                            maxHeight: '200px',  // 最大高度
                                        }
                                    }
                                }
                            }}
                        >
                                {stateSelectItem()}
                            </TextField>
                        </Box>


                        <Box sx={{ paddingTop: '80px' }}>
                            <Button
                                type='submit'
                                sx={{
                                    borderRadius: '30px',
                                    height: '60px',
                                    width: '200px',
                                    bgcolor: '#FFC107',
                                    border: '1px solid #FFC107',
                                    color: '#141F39',
                                    '&:hover': { bgcolor: '#FFC107' },
                                    textTransform: 'none'
                                }}
                            >
                                {t('t446')}
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        )
    }

    const item2 = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingBottom={'10px'}>
                    {t('t348')}
                </Typography>
                <Typography fontSize={20} fontWeight={500} color={'#141F39'} paddingBottom={'40px'} textAlign={'center'}>
                    Pay your monthly installment in person at one of our partner merchants near you.
                </Typography>
                <Box sx={{
                    marginTop: '0px',
                    padding:  isDesktop ? '20px 40px' : '20px 20px',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                   
                    <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#FFF8E7', padding: '5px 10px', borderRadius: '5px', marginBottom: '20px'}}>
                        <img src={IconTip} alt="icon" style={{ width: 20, height: 20, marginRight: '8px' }} />
                        <span style={{fontStyle: 'italic', fontSize: '16px' ,fontWeight: '500',}}>{'You will be given a transaction slip once the transaction has been approved. Please keep it for record purposes.'}</span>
                    </div>
                            

                    <div style={{ width: '100%', padding: '10px 0px',}}>
                        {merchants.map((merchant, index) => {
                        const isExpanded = expandedItems[index] || false
                        // 判断是否有子信息（如果 phone 为空则没有详情）
                        const hasDetails = merchant.addresses && merchant.addresses.length > 0

                        return (
                        <div 
                            key={index}
                            style={{
                            width: '100%',
                            paddingBottom: '20px',
                            overflow: 'hidden',
                            backgroundColor: '#fff',
                            }}
                        >
                            {/* 头部 - 点击切换 */}
                            <div
                            onClick={() => hasDetails && toggleExpand(index)}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                              
                                cursor: hasDetails ? 'pointer' : 'default',
                                transition: 'background-color 0.2s'
                            }}
                            >
                            <span style={{ 
                                fontSize: '16px', 
                                fontWeight: '600',
                                color: '#141F39'
                            }}>
                                {merchant.name}
                            </span>

                            {/* 加号/减号图标 */}
                            {hasDetails && (<img src={isExpanded ? IconHide : IconExpand} alt="icon" style={{ width: 24, height: 24,}} />)}
                            </div>

                            {/* 展开的内容 - 使用动画 */}
                            <div
                            style={{
                                maxHeight: isExpanded ? '500px' : '0',
                                opacity: isExpanded ? 1 : 0,
                                overflow: 'hidden',
                                padding: isExpanded ? '0px 0px' : '0 0px',
                                transition: 'all 0.3s ease-in-out',
                                width: '100%',

                            }}
                            >


                            {hasDetails && merchant.addresses.map((addr, addrIndex) => {

                                return (
                                <div 
                                    key={addrIndex}
                                    style={{
                                    padding: '10px 0',
                                    borderBottom: addrIndex < merchant.addresses.length - 1 ? '1px solid #e8e8e8' : '1px solid #999'
                                    }}
                                >
                                    {/* 电话 */}
                                    {addr.phone && (
                                    <div style={{ marginBottom: '4px' }}>
                                        <span style={{ fontWeight: '500' }}>Tel : </span>
                                        <span>{addr.phone}</span>
                                    </div>
                                    )}
                                    
                                    {/* 地址 + Copy 按钮 */}
                                    <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    gap: '12px'
                                    }}>
                                    <span style={{ 
                                        flex: 1,
                                        wordBreak: 'break-word'
                                    }}>
                                        {addr.address}
                                    </span>
                                    
                                    {/* Copy 按钮 - 点击复制该行地址 */}
                                    <button
                                        onClick={(e) => {
                                        e.stopPropagation()  // 阻止冒泡，防止触发卡片折叠
                                        handleCopy(addr.address) // 复制地址，不包含电话
                                        // 如果希望复制完整信息（含电话），改用 fullAddress
                                        // handleCopy(fullAddress);
                                        }}
                                        style={{
                                        fontSize: '12px',
                                        color: '#141F39',
                                        backgroundColor: '#FFC107',
                                        border: 'none',
                                        width: '60px',
                                        height: '24px',
                                        borderRadius: '12px',
                                        cursor: 'pointer',
                                        whiteSpace: 'nowrap',
                                        flexShrink: 0,
                                        transition: 'background-color 0.2s',
                                        fontWeight: '500'
                                        }}
    
                                    >
                                        Copy
                                    </button>
                                    </div>
                                </div>
                                )
                            })}





                            </div>
                             {isExpanded ? <div></div> : <div style={{backgroundColor:'#e8e8e8', height: '1px', width: '100%', marginTop: '10px'}}></div>}
                        </div>
                        )
                        })}
                    </div>
                    

                    <Box sx={{ textAlign: 'center', width: '100%' }}>
                    <Button
                        onClick={() => window.close()}
                        sx={{
                            borderRadius: '20px',
                            height: '40px',
                            width: '160px',
                            bgcolor: '#FFC107',
                            border: '1px solid #FFC107',
                            color: '#141F39',
                            textTransform: 'none',
                            marginTop: '30px',
                            marginBottom: '40px',
                            '&:hover': { bgcolor: '#FFC107' },
                        }}
                    >
                        Close
                    </Button>
                    </Box>
                </Box>     
            </Box>
        )
    }



    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: '#FFF8E7',
            padding: '60px 0',
            paddingLeft: isDesktop ? '240px' : '12px',
            paddingRight: isDesktop ? '240px' : '12px',
        }}>
            {step === 1 ? item1() : item2()}
        </Box>
    )
}

export default SMFindMerchant